{
  "seo": {
    "title": "Parent Dashboard Preview — Family Learning Insights",
    "description": "Explore CuriPop's parent dashboard preview with professional learning analytics, progress insights, and practical actions that help children learn more effectively.",
    "keywords": "parent dashboard preview, learning analytics for kids, child progress dashboard, family learning insights, reading level insights"
  },
  "hero": {
    "title": "Parent Dashboard Preview",
    "subtitle": "See how CuriPop turns daily activity into clear parent insights that support stronger learning habits and better outcomes over time.",
    "tags": {
      "analytics": "Progress analytics",
      "reading": "Reading-level insight",
      "controls": "Family controls"
    }
  },
  "weekly": {
    "title": "What Parents See Each Week",
    "subtitle": "The dashboard summarizes learning signals in plain language so parents can move from observation to action in minutes."
  },
  "metrics": {
    "weeklyActive": {
      "label": "Weekly active learning days",
      "value": "5 / 7",
      "delta": "+2 vs last week"
    },
    "topTopic": {
      "label": "Top topic this week",
      "value": "Science",
      "delta": "40% of exploration"
    },
    "consistency": {
      "label": "Consistency score",
      "value": "Strong",
      "delta": "Returning reliably"
    },
    "coverage": {
      "label": "Family profile coverage",
      "value": "3 children",
      "delta": "Each with own settings"
    }
  },
  "howItWorks": {
    "title": "How the dashboard works",
    "subtitle": "CuriPop combines activity patterns, topic performance, and reading-level signals so parents can support each child with focused next steps.",
    "capture": {
      "title": "Capture",
      "body": "As kids explore questions and quizzes, CuriPop tracks engagement patterns, return behavior, and topic interest by profile."
    },
    "analyze": {
      "title": "Analyze",
      "body": "The dashboard converts activity into readable insights so parents can quickly see strengths, friction points, and growth trends."
    },
    "guide": {
      "title": "Guide",
      "body": "Parents use these insights to adjust reading level, support hard topics, and reinforce consistency with short focused sessions."
    }
  },
  "example": {
    "title": "Example in action",
    "subtitle": "A parent notices quiz confidence dropping in Space while reading-level load increases. They adjust level settings and add short follow-up sessions in the same topic.",
    "week1": {
      "label": "Week 1:",
      "body": "61% topic accuracy, lower return rate"
    },
    "week2": {
      "label": "Week 2:",
      "body": "level adjusted + guided sessions"
    },
    "week3": {
      "label": "Week 3:",
      "body": "79% topic accuracy, stronger consistency"
    }
  },
  "outcomes": {
    "title": "How this helps children learn",
    "subtitle": "Parents can make smaller, smarter interventions that improve confidence and keep curiosity active.",
    "readers": {
      "title": "More confident readers",
      "body": "Reading-level feedback helps parents fine-tune content so children stay challenged without feeling overwhelmed."
    },
    "consistency": {
      "title": "Stronger learning consistency",
      "body": "Weekly activity trends help families build repeatable routines that reduce drop-off and improve retention."
    },
    "guidance": {
      "title": "Better parent guidance",
      "body": "Topic-level insight makes follow-up support practical at home, even for parents with limited prep time."
    }
  },
  "cta": {
    "title": "Want these insights for your family?",
    "subtitle": "Start free now. Upgrade when you are ready to unlock the full parent analytics dashboard and family controls.",
    "primary": "Start Free",
    "secondary": "See Family Plan"
  }
}
